import "../scss/Header.scss";
import { Icon } from "@fluentui/react/lib/Icon";
import { StringConstants } from "../Constants";

import * as React from "react";

const logosvg = (
<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="48" height="48" fill="white"/>
<rect width="48" height="48" fill="#990000"/>
<path d="M23.9225 6C25.2478 6.01538 26.5679 6.16956 27.8615 6.46007C28.4262 6.58689 28.8484 7.06092 28.9126 7.63993L29.2199 10.416C29.3589 11.6907 30.4276 12.6561 31.7018 12.6574C32.0443 12.658 32.383 12.5861 32.6995 12.4451L35.2284 11.3265C35.7543 11.0938 36.3688 11.2207 36.7615 11.6429C38.589 13.6084 39.9501 15.9657 40.7424 18.5375C40.9132 19.092 40.7166 19.6946 40.2523 20.0391L38.0109 21.7029C37.3714 22.176 36.9939 22.9273 36.9939 23.7264C36.9939 24.5252 37.3714 25.2765 38.0122 25.7507L40.2558 27.4151C40.72 27.7595 40.9168 28.3622 40.746 28.9169C39.954 31.4881 38.5937 33.8452 36.7672 35.8111C36.3749 36.2332 35.7608 36.3606 35.235 36.1284L32.6957 35.0081C31.9694 34.688 31.135 34.7349 30.4485 35.1345C29.7621 35.534 29.3051 36.2385 29.2179 37.0322L28.9126 39.808C28.8497 40.3804 28.4364 40.8513 27.8802 40.9846C25.265 41.6111 22.5402 41.6111 19.9249 40.9846C19.3685 40.8513 18.9553 40.3804 18.8924 39.808L18.5875 37.0364C18.498 36.2442 18.0405 35.5418 17.3545 35.1436C16.6685 34.7455 15.8356 34.6988 15.1116 35.0171L12.5718 36.1375C12.0457 36.3696 11.4315 36.2423 11.0393 35.8199C9.21176 33.8518 7.85141 31.4919 7.06057 28.9178C6.89025 28.3635 7.08706 27.7611 7.55105 27.4169L9.79593 25.7515C10.4354 25.2784 10.813 24.5271 10.813 23.7281C10.813 22.9291 10.4354 22.1778 9.79513 21.7041L7.55163 20.0415C7.08694 19.6972 6.88995 19.0941 7.06088 18.5392C7.85307 15.9676 9.21415 13.6103 11.0417 11.6448C11.4344 11.2225 12.0488 11.0956 12.5748 11.3283L15.1032 12.4468C15.8308 12.7683 16.6672 12.7197 17.3569 12.314C18.0436 11.9129 18.5007 11.2077 18.589 10.4139L18.8961 7.63993C18.9602 7.06063 19.3829 6.58644 19.9479 6.45989C21.2431 6.16985 22.5644 6.01573 23.9225 6ZM26.7477 16.4545H20.839L26.4458 23.7273L21.4392 30.1166C21.2538 30.3531 21.294 30.6961 21.5287 30.8827C21.6244 30.9587 21.7425 31 21.8644 31H26.7477C26.9151 31 27.0729 30.9222 27.1756 30.7891L32.1911 24.2847C32.4442 23.9567 32.4442 23.4976 32.1911 23.1696L27.1756 16.6655C27.0729 16.5324 26.9151 16.4545 26.7477 16.4545ZM19.709 17.9145L15.622 23.1665C15.4024 23.4487 15.371 23.8291 15.5278 24.1394L15.6219 24.288L19.236 28.9338L19.3252 29.0244C19.5259 29.1851 19.8049 29.1793 19.9978 29.026L20.0864 28.9371L22.499 25.8828C22.624 25.7246 22.6496 25.5138 22.5754 25.334L22.5012 25.2064L21.3478 23.7273L22.7585 21.9164L19.709 17.9145Z" fill="white"/>
</svg>
);

interface IRightPanel {
  title: string;
}

export const Header: React.FunctionComponent = () => {

  return (
    <>
      <header className="indexnow-Header">
        <div className="headerLeftElements floatLeft">
          <span className="indexNowLogo desktopOnly">{logosvg}</span>
          <span className="pageTitle">
          IndexNow Plugin
          </span>
        </div>
        <div className="headerRightElements floatRight">
          <span
            title="Help"
            onClick={() =>
              window.open(StringConstants.PluginInfoLink, "_blank")
            }
            key="headerHelp"
          >
            <span className="desktopOnly">About this plugin</span>
            <Icon iconName="Info" className="bw-Icon" />
          </span>
        </div>
      </header>
    </>
  );
};
